export interface IMaterial {
    author: string;
    availableQuantity: number;
    copyright: string;
    courseId?: number;
    custom: boolean;
    discountId: string;
    edition: string;
    groupId?: number;
    height: number;
    id: number;
    isbn: string;
    isbn10: string;
    length: number;
    name: string;
    nationalISBN: string;
    publisher: string;
    subActivityId?: number;
    weight: number;
    width: number;
    endDate?: Date;
    startDate?: Date;
    topSizeId?: number;
    bottomSizeId?: number;
}

const newMaterial = (): IMaterial => ({
    author: '',
    availableQuantity: 0,
    copyright: '',
    custom: false,
    discountId: '',
    edition: '',
    height: 0,
    id: 0,
    isbn: '',
    isbn10: '',
    length: 0,
    name: '',
    nationalISBN: '',
    publisher: '',
    weight: 0,
    width: 0,
})

export const createMaterial = <T extends Partial<IMaterial>>(initialValues: T): IMaterial & T => {
    return Object.assign(newMaterial(), initialValues);
};